import nps from "./modules/nps";

export default {
    modules: {
        nps
    }
}
